import * as React from 'react';
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import { RESTRICTION_EVENTS_NAME_MAP } from 'constants/restricted-products/restricted-products';
import { Drawer } from 'components/ui/drawer';
import { Button } from 'components/ui/ButtonGs';
import { Formatter } from 'utils';

import { JustificationFiles } from './justification-files';

type Ref = {
  open: (event: RestrictionEvent) => void;
  close: () => void;
};

type Props = {};

export type ShowEventsJustificationDrawerRef = Ref;

export const ShowEventJustificationDrawer = React.forwardRef<
  ShowEventsJustificationDrawerRef,
  Props
>((_, ref) => {
  const [open, setOpen] = React.useState(false);
  const [event, setEvent] = React.useState<RestrictionEvent>();

  const onOpenChange = React.useCallback(
    (open: boolean, event?: RestrictionEvent) => {
      setOpen(open);
      setEvent(event);
    },
    [],
  );

  React.useImperativeHandle(ref, () => {
    return {
      open: (event) => onOpenChange(true, event),
      close: () => onOpenChange(false),
    };
  }, [onOpenChange]);

  if (!event) return null;

  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Content>
        <div className={'max-w-[480px] w-full mx-auto pb-10'}>
          <Drawer.Header className={'mb-6'}>
            <Drawer.Title className={'font-GilroyBold text-gray-600'}>
              Justificativa do evento de {RESTRICTION_EVENTS_NAME_MAP[event?.action]}
            </Drawer.Title>
          </Drawer.Header>
          <div className={'flex flex-col gap-2 px-4 mb-10'}>
            <p>
              Justificado por{' '}
              <span className={'font-GilroySemibold'}>
                {event.justificationUser?.name}
              </span>{' '}
              em{' '}
              <span className={'font-GilroySemibold'}>
                {Formatter.dateFull(event.updatedAt, { format: 'dd/MM/yyyy HH:mm' })}
              </span>
            </p>
            <p>Justificativa: {event?.justification}</p>
            <JustificationFiles justificationFiles={event?.justificationFiles} className={'mt-4'} />
          </div>
          <Button.Root
            type={'button'}
            size={'sm'}
            variant={'secondary'}
            className={'w-full'}
            onClick={() => onOpenChange(false)}
          >
            Fechar
          </Button.Root>
        </div>
      </Drawer.Content>
    </Drawer.Root>
  );
});
ShowEventJustificationDrawer.displayName = 'ShowEventJustificationDrawer';
